<template>
  <div>
    <div
      @click="onClick(tree)"
      class="item py-2 pr-2 d-flex"
      :class="classes(tree)"
    >
      <span>{{ tree.name }}</span>
      <svg-icon
        v-if="tree.nested && !tree.expanded"
        icon="chevron-down"
        style="pointer-events: none;"
        class="ml-auto mr-1 align-self-center"
      />
      <svg-icon
        v-if="tree.expanded"
        icon="chevron-up"
        style="pointer-events: none;"
        class="ml-auto mr-1 align-self-center"
      />
    </div>
    <tree
      v-if="tree.expanded"
      :tree="tree.nested"
      :depth="depth + 2"
      :uniq-key="uniqKey"
      @input="onInput"
    />
  </div>
</template>

<script>
import cloneDeep from 'clone';
import Tree from './Tree.vue';

export default {
  props: {
    node: {
      type: Object,
      default: () => ({})
    },
    depth: {
      type: Number,
      default: 0
    },
    uniqKey: {
      type: String,
      default: 'name'
    },
    action: {
      validator(val) {
        return typeof val === 'function';
      },
      default() {
        return function(val) {
          const emitValue = {
            name: val.name || 'placeholder',
            value: val.params
          };
          this.$emit('input', emitValue);
          return emitValue;
        };
      }
    }
  },

  components: {
    Tree
  },

  data() {
    return {
      tree: {}
    };
  },

  methods: {
    prepare(val) {
      const tree = cloneDeep(val);
      this.tree = {
        ...tree,
        expanded: this.tree.hasOwnProperty('expanded')
          ? this.tree.expanded
          : false
      };
    },
    classes() {
      return [`pl-${2 + this.depth}`];
    },
    onClick() {
      if (this.tree.nested) {
        this.tree.expanded = !this.tree.expanded;
      } else {
        this.$emit('input', this.tree);
      }
    },
    onInput(value) {
      this.action(value);
    }
  },

  beforeMount() {
    this.prepare(this.node);
  },

  watch: {
    node(val) {
      this.prepare(val);
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  cursor: pointer;

  &:hover {
    background: lighten($lighten, 30%);
  }

  &.active {
    background: lighten($secondary, 25%);
  }
}
</style>
